import { computed } from "vue";

import { EID_PAGE_SCHEDULE } from "@/data/eid";

function toTimestamp(value: string) {
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? null : parsed;
}

export function useEidWindow() {
  const startsAt = toTimestamp(EID_PAGE_SCHEDULE.startsAt);
  const endsAt = toTimestamp(EID_PAGE_SCHEDULE.endsAt);

  const isActive = computed(() => {
    if (startsAt === null || endsAt === null) return false;

    const now = Date.now();
    return now >= startsAt && now < endsAt;
  });

  return {
    startsAt: EID_PAGE_SCHEDULE.startsAt,
    endsAt: EID_PAGE_SCHEDULE.endsAt,
    isActive,
  };
}
